import * as Widget from './base';
import * as WidgetHelper from './helper';

export function show(config) {
  var inline = Widget.get(config);

  if (inline) {
    inline.classList.remove('invisible');
  }
}

export function hide(config) {
  var inline = Widget.get(config);

  if (inline) {
    inline.classList.add('invisible');
  }
}

export function toggle(config) {
  Widget.toggle(config);
}

export function init(config) {
  if (Driftrock.settings.debug) {
    console.info(`[Driftrock] Initialising inline widget: ${config.widget.id}`);
  }

  if (config.widget_html) {
    const css_selector = config.widget.format_config.options.css_selector || `.driftrock-${config.widget.id}`;
    var element = document.querySelector(css_selector);

    if (element) {
      element.innerHTML = config.widget_html;

      Widget.init_content(config);

      WidgetHelper.setup_open(config, show);
    }
  }
}
